<template>
  <v-dialog
    width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
    persistent
    @keydown.esc="$emit('update:opened', false)"
  >
    <input
      type="file"
      style="display: none"
      ref="selectedDocuments"
      multiple
      @change="onDocumentsPicked"
    />

    <v-card flat @drop.prevent="addFile" @dragover.prevent>
      <v-card-title class="title"> Attach Documents </v-card-title>
      <v-divider />
      <v-alert
        :value="true"
        outline
        block
        :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
        color="primary"
        class="text-xs-left mb-4"
        :class="$vuetify.breakpoint.smAndUp ? 'mx-4' : 'mx-2'"
      >
        {{ $t('alerts.dragAndDropFiles') }}
      </v-alert>
      <v-card-text class="mb-1 mt-1">
        <v-layout column>
          <v-flex class="text-xs-left mb-2 font-weight-bold">
            <v-layout align-center>
              <div class="py-3">{{ $t('documents.selectedDocuments') }}:</div>
              <v-spacer />
              <v-progress-circular
                v-if="documentImporting"
                indeterminate
                size="25"
                class="primary--text mr-2"
              />
              <v-btn
                outline
                class="default-input text-capitalize primary--text"
                :disabled="documentImporting"
                @click="pickDocuments"
              >
                <v-layout align-center>
                  <v-icon class="mr-2" size="20">add</v-icon>
                  {{ $t('documents.selectFiles') }}
                </v-layout>
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex class="text-xs-left mb-4" v-if="isEmpty(documentsToImport)">
            No documents selected.
          </v-flex>
          <v-flex class="mb-4" v-else>
            <v-layout
              align-center
              :key="i"
              v-for="(doc, i) in documentsToImport"
            >
              <v-icon color="primary"> insert_drive_file </v-icon>
              <span class="ml-1 my-1">{{ doc.name }}</span>
              <v-spacer />
              <v-icon
                @click="documentsToImport.splice(i, 1)"
                style="cursor: pointer"
                color="error"
                >cancel</v-icon
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="text-capitalize primary"
          @click="importDocuments()"
          :disabled="documentImporting || isEmpty(documentsToImport)"
        >
          {{ $t('documents.uploadAll') }}
        </v-btn>
        <v-btn
          class="text-capitalize primary--text"
          outline
          @click="
            $emit('update:opened', false);
            documentsToImport = [];
          "
        >
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    opened: {
      type: Boolean,
    },
  },

  data() {
    return {
      documentsToImport: [],
      documentImporting: false,
    };
  },

  methods: {
    isEmpty,

    pickDocuments() {
      const input = this.$refs.selectedDocuments;
      input.type = 'text';
      input.type = 'file';
      this.$refs.selectedDocuments.click();
    },

    async addFile(e) {
      this.importDocumentsDialogOpened = true;
      this.documentImporting = true;
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      this.documentsToImport.push(...droppedFiles);
      this.documentImporting = false;
    },

    async onDocumentsPicked(e) {
      this.documentImporting = true;
      const documents = e.target.files;

      if (documents) {
        this.documentsToImport.push(...documents);
      }

      this.documentImporting = false;
    },

    async importDocuments() {
      this.sending = true;
      this.$emit('update:opened', false);
      this.$emit('upload-all', this.documentsToImport);
    },
  },

  watch: {
    opened: {
      async handler(value) {
        this.documentsToImport = [];
        this.documentImporting = false;
      },
    },
  },
};
</script>

<style scoped lang="postcss"></style>
